import React from 'react';
import './MusicMarketingFirstSection.scss';
import leftSVG from '../../../assets/Images/Marketing/rocket bg element.svg';  // Update the path as per your project structure
import rightSVG from '../../../assets/Images/Marketing/piano bg element.svg';  // Update the path as per your project structure
import UnifiedButton from '../../shared/Button';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function MusicMarketingFirstSection() {

    const navigate = useNavigate()
    const handleplaylistformClick = () => {
        console.log('Navigating to /pricing');
        navigate('/support/legal-forms/3');
        window.scrollTo(0, 0);
    };
    return (
        <Box className="music-marketing-section">
            <img src={leftSVG} alt="Left SVG" className="left-svg" />
            <Box className="content">
                <Typography variant='h3'>
                    <span className="highlight">Boost</span> Your Music with Expert Marketing
                </Typography>
                <Typography>Apply for our exclusive, invite-only label and artist services to expand your audience.</Typography>
                <Box textAlign={'center'}>
                    <UnifiedButton onClick={handleplaylistformClick} className="apply-button" textContent={"Apply Now"} />
                </Box>
            </Box>
            <img src={rightSVG} alt="Right SVG" className="right-svg" />
        </Box>
    );
}

export default MusicMarketingFirstSection;
